import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useAppContext } from "../../../2_ksbHub/context/appContext";
import { useEventManagerContext } from "../context/eventContext";
import useEventStats from "./useEventStats";
import { useMemo } from "react";

function useViewOptions() {
  const theme = useTheme();

  const { isMobile, isATeacher, isAStudent, currentUser } = useAppContext();

  const { angebote, jobs, isAnEventManagerAdmin } = useEventManagerContext();

  const {
    mySlotsCount,
    openLeitungTotal,
    totalLeitung,
    openSuSTotal,
    totalTeam,
  } = useEventStats(angebote, jobs, currentUser);

  return useMemo(
    () => [
      {
        id: "all",
        label: "Alle",
      },
      {
        id: "mine",
        label: (
          <Box sx={{ display: "flex", gap: 0.5 }}>
            Meine
            <Box
              component="span"
              sx={{
                color: theme.palette.eventManager.slot.reserved,
                fontWeight: 600,
              }}
            >
              ({mySlotsCount})
            </Box>
          </Box>
        ),
      },

      ...(isATeacher || isAnEventManagerAdmin
        ? [
            {
              id: "leitung",
              label: (
                <Box sx={{ display: "flex", gap: 0.5 }}>
                  {isMobile ? "LP" : "LP offen"}
                  {openLeitungTotal > 0 && (
                    <Box
                      component="span"
                      sx={{
                        color: theme.palette.warning.main,
                        fontWeight: 600,
                      }}
                    >
                      ({openLeitungTotal} / {totalLeitung})
                    </Box>
                  )}
                </Box>
              ),
            },
          ]
        : []),

      ...(isAStudent || isAnEventManagerAdmin
        ? [
            {
              id: "student",
              label: (
                <Box sx={{ display: "flex", gap: 0.5 }}>
                  {isMobile ? "SuS" : "SuS offen"}
                  {openSuSTotal > 0 && (
                    <Box
                      component="span"
                      sx={{
                        color: theme.palette.warning.main,
                        fontWeight: 600,
                      }}
                    >
                      ({openSuSTotal} / {totalTeam})
                    </Box>
                  )}
                </Box>
              ),
            },
          ]
        : []),
    ],
    [
      mySlotsCount,
      openLeitungTotal,
      totalLeitung,
      openSuSTotal,
      totalTeam,
      isMobile,
      isATeacher,
      isAStudent,
      isAnEventManagerAdmin,
      theme,
    ],
  );
}

export default useViewOptions;
